export default (pallet = { title: '', colors: {}, logo: '', company: '' }) => ({
  title: 'light' || pallet.title,

  colors: {
    ...pallet.colors,
  },
  ...pallet.logo,
  ...pallet.company,
});
